var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.666 11.72c0-5.204 4.074-9.053 9.334-9.053s9.333 3.849 9.333 9.053c0 5.202-4.074 9.054-9.333 9.054-.942 0-1.85-.124-2.698-.358a.738.738 0 0 0-.498.04l-1.86.817a.748.748 0 0 1-1.051-.663l-.055-1.664a.747.747 0 0 0-.246-.529 8.861 8.861 0 0 1-2.926-6.696zm6.472-1.704L6.4 14.373c-.273.41.25.887.639.583l2.947-2.233a.55.55 0 0 1 .677 0l2.175 1.635a1.406 1.406 0 0 0 2.024-.374l2.737-4.357c.274-.41-.249-.878-.638-.583l-2.947 2.233a.538.538 0 0 1-.668 0l-2.179-1.635a1.398 1.398 0 0 0-2.029.374"
  })));
};
export default SvgMessenger;